import { forwardRef } from 'react';
import { StyledCard } from './style';

const Card = forwardRef(
    ({ children, showShadow, padding, className, grow, fill }, ref) => {
        return (
            <StyledCard
                ref={ref}
                className={className}
                size="small"
                $showShadow={showShadow}
                $padding={padding}
                $grow={grow}
                $fill={fill}
            >
                {children}
            </StyledCard>
        );
    }
);

export default Card;
